<mat-form-field [appearance]="appearance">
  <mat-label>{{ label }}</mat-label>
  <mat-select
    [value]="value"
    (selectionChange)="onSelectionChange($event.value)"
    [disabled]="disabled"
    [required]="isRequired"
  >
    @if (!isRequired) {
      <mat-option [value]="null" class="null-value">Aucun</mat-option>
    }
    @for (user of userService.listByRole(userRoles) | async; track $index) {
      <mat-option [value]="user.id">
        {{ user | userLabel }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
